import React from "react";
import { Button, ButtonProps } from "@material-ui/core";

export type ActionProps = {
  variant?: "primary";
  label?: string;
} & Omit<ButtonProps, "variant">;

export const Action: React.FC<ActionProps> = ({
  variant,
  label = null,
  children,
  ...props
}) => (
  <Button
    data-testid={`Action${variant === "primary" ? "--primary" : "--secondary"}`}
    disableElevation
    size="large"
    variant={variant === "primary" ? "contained" : "text"}
    color="primary"
    {...props}
  >
    {children ? children : label}
  </Button>
);
